import { Link, useLocation } from "react-router-dom";
import React from "react";

import { all_routes } from "../../router/all_routes";

const DashboardMenu = () => {
  const routes = all_routes;
  const location = useLocation();
  const isLinkActive = (route: string) => {
    return location.pathname === route;
  };
  return (
    <>
      <div className="container py-1 px-3"></div>

      <div className="dashboard-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="dashboard-menu">
                <ul className="row">
                  <li className="col-4 pe-0">
                    <Link
                      to={routes.userBookings}
                      className={
                        isLinkActive(routes.userBookings) ||
                        isLinkActive(routes.userBookingInprogress) ||
                        isLinkActive(routes.userBookingUpcoming) ||
                        isLinkActive(routes.userBookingComplete) ||
                        isLinkActive(routes.userBookingCancelled)
                          ? "active"
                          : ""
                      }
                    >
                      <span className="text-nowrap">My Bookings</span>
                    </Link>
                  </li>

                  <li className="col-4 pe-0">
                    <Link
                      to={routes.userPayment}
                      className={
                        isLinkActive(routes.userPayment) ? "active " : ""
                      }
                    >
                      <span>Payments</span>
                    </Link>
                  </li>
                  <li className="col-4">
                    <Link
                      to={routes.userSettings}
                      className={
                        isLinkActive(routes.userSettings) ||
                        isLinkActive(routes.userSecurity) ||
                        isLinkActive(routes.preference) ||
                        isLinkActive(routes.notification) ||
                        isLinkActive(routes.userIntegration)
                          ? "active "
                          : ""
                      }
                    >
                      <span>Settings</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardMenu;
